import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, ShoppingCart, FileText, Truck, Package, DollarSign, ChevronRight } from 'lucide-react';

const ICONS = { TrendingUp, ShoppingCart, FileText, Truck, Package, DollarSign };

const statusBadge = (action) => {
  const a = (action || '').toUpperCase();
  if (['COMPLETED', 'DELIVERED', 'POSTED', 'PAID'].includes(a)) return 'bg-emerald-100 text-emerald-800';
  if (['OPEN', 'IN_PROCESS', 'CREATED', 'DRAFT'].includes(a)) return 'bg-amber-100 text-amber-800';
  if (['CANCELLED', 'REJECTED'].includes(a)) return 'bg-red-100 text-red-800';
  return 'bg-slate-100 text-slate-700';
};

const RecentActivityFeed = ({ activities }) => {
  const navigate = useNavigate();

  return (
    <div className="divide-y divide-slate-100" data-testid="recent-activity-feed">
      {activities.map((act, i) => {
        const Icon = ICONS[act.icon] || FileText;
        return (
          <button
            key={`${act.number}-${i}`}
            onClick={() => act.path && navigate(act.path)}
            className="w-full flex items-center gap-3 py-2.5 text-left hover:bg-slate-50 -mx-2 px-2 rounded-md transition-colors group"
            data-testid={`activity-${act.number}`}
          >
            <span className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-slate-500" strokeWidth={1.75} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-slate-800 truncate">{act.number}</p>
              <p className="text-xs text-slate-400">{act.time}</p>
            </div>
            <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${statusBadge(act.action)}`}>
              {act.action}
            </span>
            <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-orange-500 transition-colors" />
          </button>
        );
      })}
    </div>
  );
};

export default RecentActivityFeed;
